/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { InputFormType } from "./InputFormType";
import { InputField } from "./InputField";
export const InputForm = core.serialization.object({
    type: InputFormType,
    fields: core.serialization.list(InputField),
});
